import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectEmployers = (state: any) => state.employers || initialState;

const loadingSelector = createSelector(
  selectEmployers,
  employersState => employersState.loading,
);

const employersSelector = createSelector(
  selectEmployers,
  employersState => employersState.employers,
);

const employerSelector = createSelector(
  selectEmployers,
  employersState => employersState.employer,
);

const employerJobsSelector = createSelector(
  selectEmployers,
  employersState => employersState.employerJobs,
);

const makeSelectPageCount = createSelector(
  selectEmployers,
  employersState => employersState.pageCount,
)

const makeSelectCurrentPage = createSelector(
  selectEmployers,
  employersState => employersState.currentPage,
);

const loadingEmployerJobsSelector = createSelector(
  selectEmployers,
  employersState => employersState.employesJobsLoading,
);

export { 
  loadingSelector,
  loadingEmployerJobsSelector,
  employersSelector,
  employerJobsSelector,
  makeSelectPageCount,
  makeSelectCurrentPage,
  employerSelector
};
